var map = {
	"./drdoctor/img/icons/new_profile_icon.png": 650,
	"./freedoctor/img/icons/new_profile_icon.png": 651,
	"./freelegal/img/icons/new_profile_icon.png": 652,
	"./legalchief/img/icons/new_profile_icon.png": 653,
	"./medi4u/img/icons/new_profile_icon.png": 654
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 649;